<div class="content">
  <div class="alert-wrapper">
    <glxy-alert type="tip" class="inputs">
      <div [innerHtml]="'AUTOMATIONS.EDITOR.TASKS.CHARGE_INVOICE.DESCRIPTION' | translate"></div>
    </glxy-alert>
    <glxy-alert type="warning">
      <div [innerHtml]="'AUTOMATIONS.EDITOR.TASKS.CHARGE_INVOICE.WARNING' | translate"></div>
    </glxy-alert>
  </div>
</div>
